/**
 * Kampanjspalternas pilar.
 *
 * Knapparna finns alltid, som i designen, men är INAKTIVA när det inte går att
 * bläddra. En inaktiv knapp ljuger inte — den säger att kontrollen finns och
 * att det inte finns något mer åt det hållet. Att dölja dem helt gjorde att
 * designen saknade sina pilar; att låta dem se aktiva ut utan att göra något
 * vore värre.
 *
 * Rullningen sker på banan själv, inte med scrollIntoView. scrollIntoView
 * rullar VARJE rullbar förfader, alltså även dokumentet: anropet som satte
 * utgångsläget kastade besökaren 700 px ner på startsidan vid inladdning.
 * Knapplägena sätts därför för sig, och banan rullas bara när någon klickar.
 */
( function () {
	function bana( el ) {
		var p = el.parentElement;
		while ( p && p !== document.body ) {
			if ( p.scrollWidth > p.clientWidth + 1 ) { return p; }
			p = p.parentElement;
		}
		return null;
	}
	function init( spalt ) {
		var pilar = spalt.querySelector( '.bm-kampanj__pilar' );
		var kort = spalt.querySelectorAll( '.bm-kampanj__kort' );
		if ( ! pilar ) { return; }
		pilar.hidden = false;
		var i = 0;
		var knappar = pilar.querySelectorAll( '.bm-kampanj__pil' );
		function knapplage() {
			knappar.forEach( function ( b ) {
				var r = parseInt( b.dataset.bmRiktning, 10 );
				b.disabled = ( r < 0 && i <= 0 ) || ( r > 0 && i >= kort.length - 1 );
			} );
		}
		function rulla() {
			var b = kort[ i ] && bana( kort[ i ] );
			if ( b ) {
				b.scrollTo( { left: kort[ i ].offsetLeft - kort[ 0 ].offsetLeft, behavior: 'smooth' } );
			}
			knapplage();
		}
		pilar.addEventListener( 'click', function ( e ) {
			var b = e.target.closest( '.bm-kampanj__pil' );
			if ( ! b || b.disabled ) { return; }
			i = Math.min( kort.length - 1, Math.max( 0, i + parseInt( b.dataset.bmRiktning, 10 ) ) );
			rulla();
		} );
		knapplage();
	}
	document.addEventListener( 'DOMContentLoaded', function () {
		document.querySelectorAll( '.bm-kampanj__spalt' ).forEach( init );
	} );
}() );
